<div *ngIf="customization">
  <lms-breadcrumb [label]="customization.name"></lms-breadcrumb>
  <lms-toolbar> </lms-toolbar>

  <div class="row">
    <div class="col s12">
      <lms-customization-editor
        [customization]="customization"
        (saved)="onUpdateCustomization($event)"
      ></lms-customization-editor>
    </div>
  </div>
</div>
